const projects = [
  {
    id: "tapdosh",
    title: "TapDosh",
    category: "Product",
    featured: true,
    accentFrom: "#0f172a",
    accentTo: "#2563eb",
    shortLabel: "Flagship Product",
    description:
      "A student-focused food concierge and restaurant discovery platform built for the Al-Hikmah University area in Ilorin. The product experience centers on trusted restaurant discovery, simple ordering, and WhatsApp-based checkout.",
    highlights: [
      "Flagship campus-focused product",
      "Live food ordering experience",
      "Strong portfolio centerpiece",
      "Combines product thinking, branding, and frontend execution",
    ],
    tags: [
      "React",
      "JavaScript",
      "Product Design",
      "Campus Commerce",
      "FoodTech",
    ],
    live: "https://tapdosh.com/",
    github: "https://github.com/DoshCoder/TapDosh",
  },
  {
    id: "superstar-mc-fresh",
    title: "SUPERSTAR MC FRESH",
    category: "Business Website",
    featured: true,
    accentFrom: "#7c2d12",
    accentTo: "#ea580c",
    shortLabel: "Brand Site",
    description:
      "A promotional and brand-focused website project built to present a strong online presence for a client brand.",
    highlights: [
      "Clean branding direction",
      "Simple public-facing experience",
      "Client presentation website",
    ],
    tags: ["HTML", "CSS", "JavaScript", "Branding"],
    live: "https://doshcoder.github.io/SUPERSTAR-MC-FRESH/",
    github: null,
  },
  {
    id: "dr-kazeem-adebayo-oladimeji",
    title: "Dr. Kazeem Adebayo Oladimeji",
    category: "Academic Website",
    featured: true,
    accentFrom: "#1e3a8a",
    accentTo: "#3b82f6",
    shortLabel: "Academic Profile",
    description:
      "A professional academic website designed to present profile information, achievements, and institutional credibility in a clear and respectable format.",
    highlights: [
      "Academic profile presentation",
      "Trust-building layout",
      "Professional information structure",
    ],
    tags: ["Academic", "Portfolio", "Responsive Design"],
    live: "https://doshcoder.github.io/Dr.-Kazeem-Adebayo-Oladimeji/",
    github: null,
  },
  {
    id: "muritala-damola-sekinat",
    title: "Muritala Damola Sekinat",
    category: "Portfolio Website",
    featured: false,
    accentFrom: "#14532d",
    accentTo: "#22c55e",
    shortLabel: "Personal Site",
    description:
      "A personal profile website built to showcase identity, presentation, and digital presence in a polished format.",
    highlights: [
      "Strong visual clarity",
      "Personal brand presentation",
      "Mobile-friendly layout",
    ],
    tags: ["Portfolio", "UI", "Responsive"],
    live: "https://doshcoder.github.io/Muritala-Damola-Sekinat/",
    github: null,
  },
  {
    id: "prof-l-f-oladimeji",
    title: "Prof. L.F. Oladimeji",
    category: "Academic Website",
    featured: false,
    accentFrom: "#581c87",
    accentTo: "#a855f7",
    shortLabel: "Professor Profile",
    description:
      "An academic profile website tailored for credibility, visibility, and structured presentation of professional information.",
    highlights: [
      "Institutional-style presentation",
      "Clear information hierarchy",
      "Professional profile experience",
    ],
    tags: ["Academic", "Profile", "Web Design"],
    live: "https://doshcoder.github.io/Prof.-L.F.-Oladimeji/",
    github: null,
  },
  {
    id: "chief-oladimeji",
    title: "Chief Oladimeji",
    category: "Profile Website",
    featured: false,
    accentFrom: "#78350f",
    accentTo: "#f59e0b",
    shortLabel: "Profile Site",
    description:
      "A profile-driven website project built to create a strong online identity with a polished and accessible web presence.",
    highlights: [
      "Respectable visual tone",
      "Accessible profile structure",
      "Professional web presence",
    ],
    tags: ["Profile", "Frontend", "Responsive Design"],
    live: "https://doshcoder.github.io/Chief-Oladimeji/",
    github: null,
  },
  {
    id: "dr-r-m-oladimeji",
    title: "Dr. R.M. Oladimeji",
    category: "Academic Website",
    featured: false,
    accentFrom: "#0f766e",
    accentTo: "#14b8a6",
    shortLabel: "Academic Site",
    description:
      "A professional website for academic presentation, profile visibility, and structured information display.",
    highlights: [
      "Professional academic presentation",
      "Simple navigation",
      "Credible content layout",
    ],
    tags: ["Academic", "Portfolio", "Web UI"],
    live: "https://doshcoder.github.io/Dr.-R.M.-Oladimeji/",
    github: null,
  },
  {
    id: "olasnutrition",
    title: "OlasNutrition",
    category: "Business Website",
    featured: true,
    accentFrom: "#166534",
    accentTo: "#84cc16",
    shortLabel: "Nutrition Brand",
    description:
      "A business website project designed to support product presentation, trust, and brand visibility for a nutrition-focused business.",
    highlights: [
      "Business-focused design",
      "Brand-led presentation",
      "Clean marketing layout",
    ],
    tags: ["Business", "Branding", "Responsive", "Frontend"],
    live: "https://doshcoder.github.io/OlasNutrition/",
    github: null,
  },
  {
    id: "dr-haruna-sanusi-lafiagi",
    title: "Dr. Haruna Sanusi Lafiagi",
    category: "Open Source",
    featured: true,
    accentFrom: "#111827",
    accentTo: "#4f46e5",
    shortLabel: "GitHub Repository",
    description:
      "A professional academic portfolio repository for a senior lecturer, focused on research, publications, teaching experience, and contact information.",
    highlights: [
      "Open-source academic web project",
      "Portfolio architecture for scholars",
      "Strong credibility-focused presentation",
    ],
    tags: ["GitHub", "Academic", "Portfolio", "Frontend"],
    live: null,
    github: "https://github.com/DoshCoder/Dr.-Haruna-Sanusi-Lafiagi",
  },
];

export default projects;
